export default __webpack_public_path__ + "static/media/coreCard4.bad4ed38.svg";